import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {getPropertyNoun} from "../../offer/utils/get_property_noun";
import {IUnlockChoiceLeadRequest} from "../types/IUnlockChoiceLeadRequest";

export const UNLOCK_CHOICE_PRICE_NEGOTIATION_SHOWN_STORAGE_KEY = "unlock_choice_price_negotiation_shown";

export const UNLOCK_CHOICE_PRICE_NEGOTIATION_ARMING_DELAY_MS = 500;

export const UNLOCK_CHOICE_PRICE_NEGOTIATION_LEAD: Omit<IUnlockChoiceLeadRequest, "formLocation"> = {
    source: ApplicationSource.Property,
    ctaText: "Negocjuj cenę",
    confirmationSubject: ({propertyNumber, offerType}) => {
        const {genitive} = getPropertyNoun(offerType);

        return propertyNumber ? `negocjacji ceny ${genitive} ${propertyNumber}` : `negocjacji ceny ${genitive}`;
    }
};
import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {getPropertyNoun} from "../../offer/utils/get_property_noun";
import {IUnlockChoiceLeadRequest} from "../types/IUnlockChoiceLeadRequest";

export const UNLOCK_CHOICE_PRICE_NEGOTIATION_SHOWN_STORAGE_KEY = "unlock_choice_price_negotiation_shown";

export const UNLOCK_CHOICE_PRICE_NEGOTIATION_ARMING_DELAY_MS = 500;

export const UNLOCK_CHOICE_PRICE_NEGOTIATION_LEAD: Omit<IUnlockChoiceLeadRequest, "formLocation"> = {
    source: ApplicationSource.Property,
    ctaText: "Negocjuj cenę",
    confirmationSubject: ({propertyNumber, offerType}) => {
        const {genitive} = getPropertyNoun(offerType);

        return propertyNumber ? `negocjacji ceny ${genitive} ${propertyNumber}` : `negocjacji ceny ${genitive}`;
    }
};
